/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { createPaymentSession, getPricing } from '../../services/payment'
import { pricingPlans } from '../../utils/pricingPlans'
import { Button } from '../Button'

interface PricingPlan {
  price_id: string
  name: string
  price: number
  description: string
  features: string[]
  type: string
}

interface PricingData {
  month: PricingPlan[]
  year: PricingPlan[]
}

export const PricingPlans = () => {
  const { t } = useTranslation()

  const [pricingData, setPricingData] = useState<PricingData>()
  const fetchPricing = async () => {
    const pricing = await getPricing()
    setPricingData(pricingPlans)
  }
  useEffect(() => {
    fetchPricing()
  }, [])

  const [activeIdx, setActiveIdx] = useState<'month' | 'year'>('month')

  const tabs: { label: string; value: 'month' | 'year' }[] = [
    { label: t('monthly'), value: 'month' },
    { label: t('annually'), value: 'year' },
  ]

  const addPremium = (price_id: string) => {
    createPaymentSession({ price_id }).then((res) => {
      window.location.href = res.url
    })
  }

  return (
    <>
      <div className="mx-auto mb-8 flex w-fit rounded-lg border border-[#505050]">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`${tab.value === activeIdx ? 'bg-[#407BFF] text-white' : 'transparent text-[#1e2330]'} flex h-[46px] w-[100px] flex-col items-center justify-center rounded-lg`}
            onClick={() => setActiveIdx(tab.value)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <ul className="mx-auto grid max-w-[660px] grid-cols-1 gap-5 sm:grid-cols-2">
        {pricingData &&
          pricingData[activeIdx].map(
            ({ name, price, description, features, price_id }, index) => (
              <li
                key={index}
                className="flex flex-col rounded-lg border border-[#c1c1c1] shadow-normal"
              >
                <div
                  className={`${name === 'Premium' ? 'bg-[#407BFF]' : 'bg-[#c2c2c2]'} rounded-lg px-4 pb-6 pt-4 text-center `}
                >
                  <h2
                    className={`${name === 'Premium' ? 'text-white' : 'text-black'} mb-2 text-center text-2xl font-medium`}
                  >
                    {name}
                  </h2>
                  <p
                    className={`${name === 'Premium' ? 'text-white' : 'text-black'} text-center text-2xl font-medium`}
                  >
                    ${price}
                  </p>
                </div>

                <div className="flex h-full flex-1 flex-col justify-between px-4 pb-6 pt-3">
                  <div className="mb-8">
                    <p className="mb-3 flex min-h-[110px] flex-col items-center justify-center text-center text-[18px]">
                      {description}
                    </p>
                    <ul className="flex flex-col">
                      {features.map((feature, index, array) => (
                        <li
                          key={`feature-${index}`}
                          className={`${index !== array.length - 1 && 'border-b-2 border-b-[#c1c1c1]'} flex flex-col items-center justify-center px-2 py-3`}
                        >
                          <span className="text-center text-[18px] font-medium">
                            {feature}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <Button
                    type="button"
                    onClick={() => addPremium(price_id)}
                    text={name}
                    className={`${name === 'Premium' ? ' border border-transparent text-white hover:border-[#2b2b2b] hover:bg-transparent hover:text-black' : 'border border-[#2b2b2b] bg-transparent text-black hover:bg-[#407BFF] hover:text-white'} h-[46px]`}
                  />
                </div>
              </li>
            ),
          )}
      </ul>
    </>
  )
}
